import EditorCanvasComponent from "./editorCanvasComponents/EditorCanvasComponent";
import EditorToolbarComponent from "./editorToolbarComponents/EditorToolbarComponent";
import "../editorStyleSheet.css";
import PropTypes from "prop-types";
import React, {useState} from 'react';
import PdfViewerComponent from "./editorCanvasComponents/PdfViewerComponent";

const BodyComponents = ({
                            handleFullScreen,
                            isFullScreen,
                            mediaPath,
                            pdfUrl,
                            containerWidth,
                            numPages,
                            pages,
                            pageNumber,
                            setForcePageNumber,
                            configWidth,
                            setNotification,
                            articleId,
                            zoom,
                            setZoom,
                            selectedWordBbox,
                            pdfDimensions,
                            addOrUpdatePages,
                            setHoveredChunkId,
                            hoveredChunkId,
                            page
                        }) => {

    const [brightness, setBrightness] = useState(0);
    const [contrast, setContrast] = useState(0);
    let bodyWidth = "55%"
    if (configWidth) {
        bodyWidth = `calc(100% - ${configWidth}px)`;
    }
    const isImage = !!pages?.[0]?.src;

    return (
        <div style={{width: bodyWidth}}>
            <EditorToolbarComponent
                pageNumber={pageNumber}
                numPages={numPages}
                setForcePageNumber={setForcePageNumber}
                handleFullScreen={handleFullScreen}
                isFullScreen={isFullScreen}
                setNotification={setNotification}
                articleId={articleId}
                zoom={zoom}
                setZoom={setZoom}
                brightness={brightness}
                setBrightness={setBrightness}
                contrast={contrast}
                setContrast={setContrast}
            />

            { isImage ?
                <EditorCanvasComponent
                    mediaPath={mediaPath}
                    containerWidth={containerWidth}
                    pages={pages}
                    pageNumber={pageNumber}
                    setForcePageNumber={setForcePageNumber}
                    zoom={zoom}
                    setZoom={setZoom}
                    brightness={brightness}
                    contrast={contrast}
                    selectedWordBbox={selectedWordBbox}
                    pdfDimensions={pdfDimensions}
                    addOrUpdatePages={addOrUpdatePages}
                    setHoveredChunkId={setHoveredChunkId}
                    hoveredChunkId={hoveredChunkId}
                    page={page}
                /> :
                <PdfViewerComponent
                    pdf={null}
                    zoom={zoom}
                    pageViewports={[]}
                    width={containerWidth}
                    height={window.innerHeight - 120}
                    scale={zoom}
                    pageNumber={pageNumber}
                    setPageNumber={setForcePageNumber}
                    forcePageNumber={pageNumber}
                    pdfUrl={pdfUrl}
                />
            }
        </div>
    );
}

BodyComponents.propTypes = {
    mediaPath: PropTypes.string,
    pdfUrl: PropTypes.string,
    containerWidth: PropTypes.string,
    zoom: PropTypes.number,
    setZoom: PropTypes.func,
    numPages: PropTypes.number,
    pageNumber: PropTypes.number,
    articleId: PropTypes.number,
    setScale: PropTypes.func,
    configWidth: PropTypes.string,
    handleFullScreen: PropTypes.func,
    setNotification: PropTypes.func,
    isFullScreen: PropTypes.bool,
    pages: PropTypes.array,
    selectedWordBbox: PropTypes.array,
    setForcePageNumber: PropTypes.func,
    addOrUpdatePages: PropTypes.func,
    pdfDimensions: PropTypes.object,
    setHoveredChunkId: PropTypes.func,
    hoveredChunkId: PropTypes.string,
    page: PropTypes.object,
};

export default BodyComponents;